import NewTrucking from 'pages/bookings/new/trucking';
import { Dispatch, FC, SetStateAction, useCallback } from 'react';
import { Booking } from 'types';
import { useEditBookings } from './edit-booking.context';

const EditTrucking: FC = () => {
  const { booking, setBooking } = useEditBookings();

  const handleSetBooking: Dispatch<SetStateAction<Partial<Booking>>> = useCallback(
    args => {
      setBooking(previous => previous && ((typeof args === 'function' ? args(previous) : args) as Booking));
    },
    [setBooking]
  );

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h3>TRUCKING COMPANIES</h3>
      </div>
      <div className="card-body">
        <NewTrucking booking={{ ...booking }} setBooking={handleSetBooking} />
      </div>
    </div>
  );
};

export default EditTrucking;
